import { DateTime } from 'luxon'

export default {
  emits: ['errored', 'received'],

  props: {
    /**
     * An existing transfer to modify instead of create
     */
    transfer: {
      type: Object,
      default() {
        return null
      }
    },
    spaces: {
      type: Array,
      default: () => []
    },
    adjustmentReasons: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      receiveForm: this.$inertia.form({
        origin_id: null,
        origin_space_id: null,
        destination_id: null,
        destination_space_id: null,
        received_at: null,
        packages: []
      }),
      receiving: false
    }
  },

  created() {
    this.initializeForm()
  },

  computed: {
    selectedOrigin() {
      return this.locations.find((location) => location.id === this.receiveForm.origin_id)
    },
    selectedDestination() {
      return this.locations.find((location) => location.id === this.receiveForm.destination_id)
    },
    selectedDestinationSpace() {
      return this.spaces.find((space) => space.id === this.receiveForm.destination_space_id)
    },
    destinationSpaces() {
      return this.spaces.filter((space) => space.location_id === this.receiveForm.destination_id)
    },
    receiveErrors(key = null) {
      return this.receiveForm.errors || {}
    },
    hasReceiveErrors() {
      return !_.isEmpty(this.receiveErrors)
    },
    hasCountErrors() {
      const packages = this.receiveForm.packages || []

      return _.reduce(
        packages,
        function (hasError, item) {
          return this.countError(item.id) || hasError
        }.bind(this),
        false
      )
    },
    totalQuantity() {
      return (
        _.reduce(
          this.receiveForm.packages,
          function (sum, item) {
            return parseFloat(sum) + parseFloat(item.quantity)
          },
          0
        ) || 0
      )
    },
    totalActualQuantity() {
      return (
        _.reduce(
          this.transfer.packages || [],
          function (sum, item) {
            return parseFloat(sum) + parseFloat(item.quantity)
          },
          0
        ) || 0
      )
    },
    totalQuantityWithAdjustments() {
      return (
        _.reduce(
          this.receiveForm.packages,
          function (sum, item) {
            return parseFloat(sum) + parseFloat(item.quantity) + this.sumAdjustments(item)
          }.bind(this),
          0
        ) || 0
      )
    },
    totalActualQuantityWithAdjustments() {
      return (
        _.reduce(
          this.transfer.packages || [],
          function (sum, item) {
            return parseFloat(sum) + parseFloat(item.quantity) + this.sumAdjustments(item)
          }.bind(this),
          0
        ) || 0
      )
    }
  },

  watch: {
    transfer(newVal, oldVal) {
      console.log('transfer changed', newVal)

      // this.initializeForm();

      if (!newVal) {
        this.initializeForm()
      } else if (!oldVal || oldVal.id !== newVal.id) {
        this.initializeForm()
      }
    }
  },

  methods: {
    initializeForm() {
      this.receiveForm.reset()

      console.log('initializing form', this.transfer)

      if (this.transfer) {
        const { origin_id, origin_space_id, destination_id, packages } = this.transfer

        console.log('parts', destination_id)

        this.receiveForm.origin_id = origin_id
        this.receiveForm.origin_space_id = origin_space_id
        this.receiveForm.destination_id = destination_id
        this.receiveForm.packages = packages
        this.receiveForm.received_at = DateTime.utc().toISO()
      }

      this.receiveForm.packages = _.map(this.receiveForm.packages, (pkg) => {
        return {
          ...pkg,
          quantity: null
        }
      })
    },
    getReceiveError(key) {
      return this.receiveErrors[key] || null
    },
    countError(packageId) {
      const errorKey = `package_${packageId}_count`

      return this.receiveErrors[errorKey] || null
    },
    sumAdjustments(pkg) {
      const adjustments = pkg.adjustments || []

      return (
        _.reduce(
          adjustments,
          function (sum, adjustment) {
            return parseFloat(sum) + -1 * parseFloat(adjustment.amount)
          },
          0
        ) || 0
      )
    },
    receive(onSuccess, onError, onFinish) {
      this.receiving = true

      this.receiveForm.put(route('transfers.receive', { transfer: this.transfer.id }), {
        errorBag: 'receiveTransfer',
        onSuccess: (response) => {
          if (onSuccess) {
            onSuccess(response)
          }

          this.emitReceived()
        },
        onError: (response) => {
          if (onError) {
            onError(response)
          }
        },
        onFinish: (response) => {
          if (onFinish) {
            onFinish(response)
          }

          this.receiving = false
        }
      })
    },
    emitReceived() {
      this.$emit('received', this.transfer)
    },
    emitErrored() {
      this.$emit('errored', this.transfer)
    }
  }
}
